import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import {
  Text,
  TextColor,
  TextFontSize,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayMessageModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tickets/models/outputs/gateway-message.model';
import { formatDate } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/formatters/format-date';

import i18n from '@app/core/locale/i18n';

interface TicketMessageComponentProps {
  message: GatewayMessageModel;
}

export const TicketMessageComponent = ({
  message,
}: TicketMessageComponentProps): React.JSX.Element => {
  return (
    <Stack direction="column" gap={GapEnum.S}>
      <Stack justifyContent="space-between">
        <Text bold>
          {message.author?.firstName} {message.author?.lastName}
        </Text>
        <Text color={TextColor.Secondary} fontSize={TextFontSize.Medium}>
          {formatDate(message.createdAt, i18n)}
        </Text>
      </Stack>
      <p>{message.content}</p>
    </Stack>
  );
};
